










import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Base } from './base';

@Component({
    components: {},
    props: [
        'passwordLink',
        'readConfigLength',
        'textLabel'
    ],

})

export default class FormlyTextLabelComponent extends Base {

    public mounted() {
    }
}
